import { Col, Flex, Row, message } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import { ImageCapturePageFormCard } from "./components/ImageCapturePageFormCard";
import {
  createImageCapturePage,
  fetchImageCapturePageTypes,
} from "@/lib/api/resources/imageCapturePages";
import { fetchImageCaptureById } from "@/lib/api/resources/imageCaptures";
import type {
  ImageCapturePage,
  ImageCapturePageType,
} from "@rumble-it/common-lib/types/models/ImageCapture.interface";

// Form values: creation payload minus imageCapture (derived from route)
export const ImageCapturePageCreate = () => {
  const { id: imageCaptureId } = useParams();
  const navigate = useNavigate();

  const typesQuery = useQuery({
    queryKey: ["imageCapturePageTypes"],
    queryFn: fetchImageCapturePageTypes,
  });

  const { data, isLoading } = useQuery({
    queryKey: ["imageCapture", imageCaptureId],
    queryFn: () => fetchImageCaptureById(imageCaptureId as string),
    enabled: !!imageCaptureId,
  });

  const createMutation = useMutation({
    mutationFn: async (
      values: Partial<ImageCapturePage> & {
        imageCapture: string;
        type: string;
      },
    ) =>
      createImageCapturePage({
        ...values,
        imageCapture: data?.["@id"] as string,
      }),
    onSuccess: () => {
      message.success("Pagina succesvol aangemaakt");
      navigate(`/image-captures/${imageCaptureId}`);
    },
    onError: () => {
      message.error("Er is een fout opgetreden bij het aanmaken van de pagina");
    },
  });

  const pageTypes = (typesQuery.data ?? []).map((t: ImageCapturePageType) => ({
    label: t.name,
    value: t["@id"],
  }));

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Flex vertical gap={16}>
            <ImageCapturePageFormCard
              title="Pagina toevoegen"
              buttonText="Toevoegen"
              loading={typesQuery.isLoading || isLoading}
              pageTypes={pageTypes}
              mutation={createMutation}
            />
          </Flex>
        </Col>
      </Row>
    </div>
  );
};
